import styled from "styled-components";
import {
    AddPropertyCard,
    StyledPropertyCard,
} from "../modals/propertyManagementModal/propertyManagementModal.styled";

export const Container = styled.div`
    display: flex;
    flex-flow: column;
    gap: 0.4rem;
    height: 14rem;
    overflow-y: auto;
    overflow-x: hidden;
    max-width: fit-content;
    padding-right: 1rem;

    @media (max-width: 768px) {
        padding-right: 0;
    }
`;

export const StyledTableBar = styled(StyledPropertyCard)`
    width: 30rem;

    user-select: none;

    min-height: 3rem;
    max-height: 3rem;
    word-break: break-word;
    overflow: hidden;

    background: ${(props) => props.theme.colors.neutral[25]};
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);

    color: ${(props) => props.theme.colors.primary[200]};

    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const AddTableBar = styled(AddPropertyCard)`
    user-select: none;
    width: 30rem;
    min-height: 3rem;
    max-height: 3rem;

    background: ${(props) => props.theme.colors.neutral[25]};
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);

    &:hover {
        background: ${(props) => props.theme.colors.neutral[50]};
        cursor: pointer;
    }

    color: ${(props) => props.theme.colors.primary[200]};
`;

export const DragHandle = styled.div`
    display: grid;
    place-items: center;
    height: 3rem;
    width: 1.8rem;
    border-right: solid 1px ${(props) => props.theme.colors.neutral[100]};
    color: ${(props) => props.theme.colors.neutral[300]};
`;
